"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleHubSaga = void 0;

var inversify_1 = require("inversify");

var effects_1 = require("redux-saga/effects");

var social_core_1 = require("@xbox/social-core");

var TitlesNormalizer_1 = require("../reducers/titlehub/TitlesNormalizer");

var TitleHubActions_1 = require("../actions/TitleHubActions");

var Utils_1 = require("./Utils");

var TitleHubSaga =
/** @class */
function () {
  function TitleHubSaga(titleHubService, telemetryService, userManager) {
    this.titleHubService = titleHubService;
    this.telemetryService = telemetryService;
    this.userManager = userManager;
    this.sagas = [this.watchFetchAllTitles(), this.watchFetchTitlesHistory(), this.watchFetchTitleByPfn(), this.watchSearchGameInMsCatalog()]; // empty
  }

  TitleHubSaga.prototype._fetchAllTitles = function (action) {
    var result, titles, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchAllTitlesInProgress(true))];

        case 1:
          _a.sent();

          this.telemetryService.trackEvent("fetchAllTitles");
          return [4
          /*yield*/
          , this.titleHubService.getAllTitles()];

        case 2:
          result = _a.sent();
          titles = TitlesNormalizer_1.titlesNormalizer(result.data.titles);
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchAllTitlesCompleted(titles))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchAllTitlesInProgress(false))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          err_1 = _a.sent();
          Utils_1.LogHttpsError("Unable to fetch titles list from xbox library", err_1);
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchAllTitlesInProgress(false))];

        case 6:
          _a.sent();

          this.telemetryService.trackException(err_1, "FetchAllTitles");
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  TitleHubSaga.prototype._fetchTitlesHistory = function (action) {
    var xuid, currentUser, result, err_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          xuid = action.payload.xuid;
          _a.label = 1;

        case 1:
          _a.trys.push([1, 6,, 8]);

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitlesHistoryInProgress(true))];

        case 2:
          _a.sent();

          if (!xuid) {
            currentUser = this.userManager.currentUser;

            if (!currentUser) {
              throw new Error("No user signed in.");
            }

            xuid = currentUser.xuid;
          }

          this.telemetryService.trackEvent("fetchTitlesHistory");
          return [4
          /*yield*/
          , this.titleHubService.getTitlesForXuid(xuid, action.payload.maxItems)];

        case 3:
          result = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitlesHistoryCompleted(result.data))];

        case 4:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitlesHistoryInProgress(false))];

        case 5:
          _a.sent();

          return [3
          /*break*/
          , 8];

        case 6:
          err_2 = _a.sent();
          console.warn("Unable to fetch titlehistory for xuid: " + action.payload.xuid);
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitlesHistoryInProgress(false))];

        case 7:
          _a.sent();

          this.telemetryService.trackException(err_2, "FetchTitlesHistory", {
            "user": xuid
          });
          return [3
          /*break*/
          , 8];

        case 8:
          return [2
          /*return*/
          ];
      }
    });
  };

  TitleHubSaga.prototype._fetchTitleByPfn = function (action) {
    var result, err_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitleByPfnInProgress(true))];

        case 1:
          _a.sent();

          this.telemetryService.trackEvent("fetchTitleByPfn");
          return [4
          /*yield*/
          , this.titleHubService.getTitlesForPfn(action.payload)];

        case 2:
          result = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitleByPfnCompleted(result.data))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitleByPfnInProgress(false))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          err_3 = _a.sent();
          console.warn("Unable to check title by Pfn, due to " + err_3);
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.fetchTitleByPfnInProgress(false))];

        case 6:
          _a.sent();

          this.telemetryService.trackException(err_3, "FetchTitlesByPfn", {
            "pfn": action.payload
          });
          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  TitleHubSaga.prototype._searchMsCatalog = function (action) {
    var platformXbox, platformDesktop, request, taskXbox, taskDesktop, _a, resultXbox, resultDesktop, err_4;

    var _this = this;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 8,, 10]);

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.searchMsCatalogInProgress(true))];

        case 1:
          _b.sent();

          this.telemetryService.trackEvent("searchMsCatalog", {
            "searchStr": action.payload
          });
          platformXbox = "windows.xbox";
          platformDesktop = "windows.desktop";
          request = {
            searchStr: action.payload,
            skip: 0,
            pageSize: 25,
            isAddon: false,
            isDemo: false
          };
          return [4
          /*yield*/
          , effects_1.spawn(function (r, p) {
            return _this.titleHubService.searchGameInMsCatalog(r, p);
          }, request, platformXbox)];

        case 2:
          taskXbox = _b.sent();
          return [4
          /*yield*/
          , effects_1.spawn(function (r, p) {
            return _this.titleHubService.searchGameInMsCatalog(r, p);
          }, request, platformDesktop)];

        case 3:
          taskDesktop = _b.sent();
          return [4
          /*yield*/
          , effects_1.join(taskXbox, taskDesktop)];

        case 4:
          _a = _b.sent(), resultXbox = _a[0], resultDesktop = _a[1];
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.searchXboxMsCatalogCompleted(resultXbox.data))];

        case 5:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.searchDesktopMsCatalogCompleted(resultDesktop.data))];

        case 6:
          _b.sent();

          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.searchMsCatalogInProgress(false))];

        case 7:
          _b.sent();

          return [3
          /*break*/
          , 10];

        case 8:
          err_4 = _b.sent();
          Utils_1.LogHttpsError("Unable to search ms catalog", err_4);
          return [4
          /*yield*/
          , effects_1.put(TitleHubActions_1.TitleHubActions.searchMsCatalogInProgress(false))];

        case 9:
          _b.sent();

          this.telemetryService.trackException(err_4, "SearchMsCatalog", {
            "searchStr": action.payload
          });
          return [3
          /*break*/
          , 10];

        case 10:
          return [2
          /*return*/
          ];
      }
    });
  };
  /*********************************************************************/

  /* Watchers
  /*********************************************************************/


  TitleHubSaga.prototype.watchFetchAllTitles = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(TitleHubActions_1.TitleHubActions.fetchAllTitles.type, this._fetchAllTitles.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  TitleHubSaga.prototype.watchFetchTitlesHistory = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(TitleHubActions_1.TitleHubActions.fetchTitlesHistory.type, this._fetchTitlesHistory.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  TitleHubSaga.prototype.watchFetchTitleByPfn = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(TitleHubActions_1.TitleHubActions.fetchTitleByPfn.type, this._fetchTitleByPfn.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  TitleHubSaga.prototype.watchSearchGameInMsCatalog = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(TitleHubActions_1.TitleHubActions.searchMsCatalog.type, this._searchMsCatalog.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  TitleHubSaga = __decorate([inversify_1.injectable(), __param(0, inversify_1.inject(social_core_1.XSocialSymbols.ITitleHubService)), __param(1, inversify_1.inject(social_core_1.XSocialSymbols.ITelemetryService)), __param(2, inversify_1.inject(social_core_1.XSocialSymbols.IUserManager)), __metadata("design:paramtypes", [social_core_1.TitleHubService, Object, Object])], TitleHubSaga);
  return TitleHubSaga;
}();

exports.TitleHubSaga = TitleHubSaga;